export class ErrorBoundaryException extends Error {
  constructor(message: string) {
    super(message)
    this.name = `${this.constructor.name}: ${this.message}`
    Error.captureStackTrace(this, this.constructor)
  }
}
